import BannerMixin from './BannerMixin'

export default {
    mixins: [
        BannerMixin
    ],

    methods: {
        getHomeBanners() {
            axios({
                method: 'get',
                url: route('api.banners.index'),
                params: {
                    where: {
                        site_id: this.$state.site.id
                    },
                    scopes: {whereType: 'home.main'},
                    paginate: 10
                }
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'banners', response.data.data.data)
                }
            })
        }
    }
}